<template lang="pug">
table.table.table-approval(:class='tableClass')
  thead
    tr(style="text-align: left; font: Bold 15px/17px Helvetica; letter-spacing: 0px; color: #343A40; opacity: 1;")
      th(v-for='c in columns', :key='c.title') 
        span.display-block.font-bold(v-html="c.title" :class="[centerColumns.length > 0 &&  !centerColumns.includes(c.key) ? 'text-center': '']")
  tbody
    tr(v-if='this.inlineFilter === true', style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(style="text-align: center;")
      td
      td
        input#name(@change="onnameChange($event)" placeholder="Tìm theo tên" style="width:100%; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 5px 10px;")
      td
        select#grades_id(@change="onGradesChange($event)" style="width:100%; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;")
          option( value='') Tất cả
          option(v-for='o in filterGrades' :value='o.id') {{o.name}}
      td(style="text-align: center;")
        select#position(@change="onClassesChange($event)" style="width:100%; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;")
          option(value='') Tất cả
          option(v-for='cc in filterClasses' :value='cc.id' :selected="cc.id === classesID") {{cc.name}}
      td(style="text-align: center;")
      td(style="text-align: center;")
        span.confirm-all(@click="onApprovalAll") Duyệt tất cả
    tr(v-if='this.data.length === 0') 
      td(style='text-align: center;' :colspan="columns.length")
        | Không có dữ liệu
    tr(v-else v-for='(item, index) in data' v-bind:id="'row' + item.user_id")
      td(v-for='c in columns' :class="[centerColumns.length > 0 &&  !centerColumns.includes(c.key) ? 'text-center': '']")
        span.list-action(v-if='c.key==="stt"' v-html='(index  + 1)')
        span.list-action.function-action(v-else-if='isAction(c)')
          small(@click="acceptItem(item)")
            img(:src="require('../../assets/images/faces/ic_check.svg')")
            span Chấp nhận
          small(@click="refuseItem(item)")
            img(:src="require('../../assets/images/faces/ic_clear.svg')")
            span Từ chối
        span.list-action(:class="[c.type==='image' ? 'img' : '']" v-html='itemValue(item, c)' v-else)
</template>

<script>
import moment from 'moment'

export default {
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    centerColumns: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    inlineFilter: {
      type: Boolean,
      default: false
    },
    filterGrades: Array,
    filterClasses: Array,
    classesID: 0
  },
  computed: {
    tableClass() {
      return `table-${this.type}`
    }
  },
  mounted () {
  },
  methods: {
    editItem(item) {
      this.$emit('onItemEdit', item)
    },
    hasValue(item, col) {
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item.created_at).format('DD/MM/YYYY - HH:mm')
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    itemValue(item, column) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'image') {
          if (item.user.avatar === '' || item.user.avatar === null) {
            return '<img src="' + require('../../assets/images/faces/ic_AvatarDefault.svg') + '" />'
          }
          return '<img src="' + item.user.avatar + '"/>'
        } else if (column.type === 'user_name') {
          return item.user.fullname
        } else if (column.type === 'date') {
          return this.fmDate(item)
        } else if (column.type === 'grade_text') {
          return item.classes.grade.name
        } else if (column.type === 'class_text') {
          return item.classes.name
        } else {
          return value
        }
      } else {
        if (typeof value === 'object') return value.name
        return value
      }
    },
    onnameChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbyname', event.target.value)
    },
    onGradesChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbygrade', event.target.value)
    },
    onClassesChange(event) {
      this.$emit('onfilterbyclasses', event.target.value)
    },
    onApprovalAll() {
      this.$emit('approvalAll')
    },
    acceptItem(item) {
      this.$emit('onAcceptItem', item)
    },
    refuseItem(item) {
      this.$emit('onRefuseItem', item)
    }
  }
}

</script>
<style lang="scss">
.text-center{text-align: center;}
.link{cursor: pointer;text-decoration: underline; color:#554BC1;}
.table-approval{
  .list-action {cursor: pointer;
    &.img{width: 48px;height: 48px; border-radius: 50%; display: flex; align-items: center; overflow: hidden; position: relative; margin: 0 auto;
      img{max-width: 100%; height: auto;}
    }
    small{display: block; margin-bottom: 10px; width: auto !important;
      img{width: 18px; height: 16px;}
      span{font-size: 13px;color: #9B9B9B; margin-left: 5px;}
      &:last-child{margin-bottom: 0;}
    }
    input, select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;}
  }
  .display-block{display: block;}
  .font-bold{font-weight: bold;}
  span.list-action{
    &.function-action{text-align: left;}
  }
  .confirm-all{text-align: left; cursor: pointer; text-decoration: underline;font-size: 13px;letter-spacing: 0px;color: #1A0DAB;}
}
</style>



// WEBPACK FOOTER //
// mbTableApproval.vue?e121b464